import { render, staticRenderFns } from "./distributionTrend2.vue?vue&type=template&id=46a179a2&scoped=true&"
import script from "./distributionTrend2.vue?vue&type=script&lang=js&"
export * from "./distributionTrend2.vue?vue&type=script&lang=js&"
import style0 from "./distributionTrend2.vue?vue&type=style&index=0&id=46a179a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a179a2",
  null
  
)

export default component.exports